<!-- <button class="btn btn-primary text-white btn-rounded mb-2">
    Order creation
</button> -->
<div class="order-creation-main">
    <mat-card class="cardWithShadow">
        <mat-card-header style="margin-bottom: 20px;">
            <mat-card-title>Scans</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-card class="cardWithShadow" *ngFor="let order of selectedRows; let i = index">
                <mat-card-header style="margin-bottom: 20px;">
                    <mat-card-title>Scan {{ order.ID }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="order-title">{{ order.data['Patient Data'].name }} {{ order.data['Patient
                        Data'].surname
                        }}</div>

                    <mat-slide-toggle style="margin-bottom: 15px;" [(ngModel)]="order.productFinished"
                        (click)="updateTotalAmount()">Finish
                        product</mat-slide-toggle>

                    <div *ngIf="order.productFinished">
                        <mat-form-field style="padding: 5px;" appearance="outline">
                            <mat-label>Top cover</mat-label>
                            <mat-select [(ngModel)]="order.topCover" name="topCover{{i}}">
                                <mat-option *ngFor="let topCover of topCovers" [value]="topCover.value">{{
                                    topCover.name
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="padding: 5px;" appearance="outline">
                            <mat-label>Bottom cover</mat-label>
                            <mat-select [(ngModel)]="order.bottomCover" name="bottomCover{{i}}">
                                <mat-option *ngFor="let bottomCover of bottomCovers" [value]="bottomCover.value">{{
                                    bottomCover.name
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- Conditionally display the order-creation-file-box only if there are matching files -->
                    <ng-container *ngIf="!hasDesignInsolesFiles(order.files)">
                        <span class="no-data-found">No files found</span>
                    </ng-container>
                    <div class="order-creation-file-box" *ngIf="hasDesignInsolesFiles(order.files)">
                        <div class="order-title">Files</div>
                        <div class="order-creation-file-list">
                            <ul class="order-creation-list">
                                <ng-container *ngFor="let file of order.files">
                                    <ng-container *ngIf="file.type === 'stl' && file.name.includes('design_insole')">
                                        <li>
                                            <div class="order-creation-file-data">
                                                <div class="order-creation-file-left">
                                                    <input type="checkbox" (click)="$event.stopPropagation()"
                                                        (change)="toggleFileSelection(file)"
                                                        [checked]="file.selected" />
                                                </div>
                                                <div class="order-creaton-file-name">{{ file.name }}</div>
                                            </div>
                                            <div class="order-creation-file-center quantity-buttton">

                                                <div class="quantity-container">
                                                    <button (click)="decrementFileCount(file)" class="border-none">
                                                        -
                                                    </button>
                                                    <span class="border-none">{{ file.quantity }}</span>
                                                    <button (click)="incrementFileCount(file)" class="border-none">
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="order-creation-file-right">
                                                <div class="price">
                                                    {{ calculatePrice(file) }} <span>usd</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ng-container>
                                </ng-container>
                            </ul>
                        </div>
                    </div>


                </mat-card-content>
            </mat-card>

        </mat-card-content>


    </mat-card>

    <div style="display: flex;">
        <mat-card style="flex: 1; margin-right: 10px;">
            <mat-card-header
                style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                <mat-card-title>Billing Address</mat-card-title>
                <button mat-mini-fab color="primary" (click)="showAddressDialog()" matTooltip="{{ 'Add' | translate}}">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-card-header>
            <mat-card-content>
                <div class="shipping-data">
                    <div class="radio-item" *ngFor="let item of addressList"
                        [ngClass]="{'checked': selectedBillingAddressId === item.ID}">
                        <input type="radio" id="{{ 'billing-' + item.ID }}" name="billingAddress"
                            [(ngModel)]="selectedBillingAddressId" [value]="item.ID" />
                        <label for="{{ 'billing-' + item.ID }}">
                            <div class="shipping-method-list">
                                <div class="shipping-method-list-left">
                                    {{ item.contactNameAndSurname }}
                                    <div class="address-data">
                                        <span>{{ item.apartmentOrOthers }}
                                            {{ item.streetNameAndNumber }} {{ item.vat }}
                                            {{ item.province }} {{ item.postalCode }}
                                            {{ item.country }}</span>

                                    </div>
                                    <div>
                                        <span>{{ item.phoneNumber }}</span>
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card style="flex: 1; margin-left: 10px;">
            <mat-card-header
                style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                <mat-card-title>Shipping Address</mat-card-title>
                <button mat-mini-fab color="primary" (click)="showAddressDialog()">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-card-header>
            <mat-card-content>
                <div class="shipping-data">
                    <div class="radio-item" *ngFor="let item of addressList"
                        [ngClass]="{'checked': selectedShippingAddressId === item.ID}">
                        <input type="radio" id="{{ 'shipping-' + item.ID }}" name="shippingAddress"
                            [(ngModel)]="selectedShippingAddressId" [value]="item.ID" />
                        <label for="{{ 'shipping-' + item.ID }}">
                            <div class="shipping-method-list">
                                <div class="shipping-method-list-left">
                                    {{ item.contactNameAndSurname }}
                                    <div class="address-data">
                                        <span>
                                            {{ item.apartmentOrOthers }}
                                            {{ item.streetNameAndNumber }} {{ item.vat }}
                                            {{ item.province }} {{ item.postalCode }}
                                            {{ item.country }}
                                        </span>
                                    </div>
                                    <div>
                                        <span>{{ item.phoneNumber }}</span>
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>


    <mat-card>
        <mat-card-header style="margin-bottom: 20px;">
            <mat-card-title>Shipping Method</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="shipping-data">
                <div class="radio-item" [ngClass]="{'checked': selectedShippingMethod?.type === 'standard'}">
                    <input type="radio" id="vanilla" name="flavor" value="vanilla"
                        (change)="selectShippingMethod({type: 'standard', cost: 50 })" />
                    <label for="vanilla">
                        <div class="shipping-method-list">
                            <div class="shipping-method-list-left">
                                Standard
                                <span>7 business days</span>
                            </div>
                            <div class="shipping-method-list-right">50 usd</div>
                        </div>
                    </label>
                </div>
                <div class="radio-item" [ngClass]="{'checked': selectedShippingMethod?.type === 'express'}">
                    <input type="radio" id="chocolate" name="flavor" value="chocolate"
                        (change)="selectShippingMethod({type: 'express', cost: 70 })" />
                    <label for="chocolate">
                        <div class="shipping-method-list">
                            <div class="shipping-method-list-left">
                                Express
                                <span>4 business days</span>
                            </div>
                            <div class="shipping-method-list-right">70 usd</div>
                        </div>
                    </label>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header style="margin-bottom: 20px;">
            <mat-card-title>Payment Method</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="payment-grid">
                <div class="radio-item" *ngFor="let card of cards"
                    [ngClass]="{'checked': form.get('selectedCardId').value === card.id}"
                    (click)="updateSelectedCardId(card.id)" style="max-width: 420px;">
                    <mat-radio-button [id]="'card-' + card.id" [value]="card.id"
                        (change)="updateSelectedCardId(card.id)"
                        [checked]="form.get('selectedCardId').value === card.id">
                        <div class="shipping-method-list">
                            <img class="card-logo" [src]="getCardImage(card.brand)" />
                            <div class="shipping-method-list-left">
                                {{ card.brand }} Card
                            </div>
                            <div class="shipping-method-list-right">
                                <span>****{{ card.last4 }}</span>
                            </div>
                        </div>
                    </mat-radio-button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Notes</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="col-xl-7 col-lg-12 col-md-12 col-sm-12" style="margin-top: 20px; margin-bottom: 20px;">
                <div class="mb-3">
                    <label for="exampleFormControlTextarea1" class="form-label"></label>
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                        [(ngModel)]="notes"></textarea>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <div class="col-md-12 text-center">
        <button mat-raised-button color="primary" style="width: 150px; height: 80px; font-size: 15px;"
            (click)="createOrder();">
            Pay {{ totalAmount }}USD
        </button>
    </div>

</div>

<!-- Address popup -->
<p-dialog header="New Address" [(visible)]="isAddressesPopup" [style]="{ width: '50vw' }" [baseZIndex]="10000"
    [draggable]="false" [modal]="true">
    <div class="address-form">
        <form action="" [formGroup]="addressForm" style="display: flex; flex-direction: column; gap: 12px;">
            <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">Select Country<sup
                        class="required">*</sup></label>
                <div class="">
                    <p-dropdown [options]="countryList" [filter]="true" filterBy="name" formControlName="country"
                        optionLabel="name" [showClear]="true" placeholder="Select a Country">
                        <ng-template let-country pTemplate="item">
                            <div class="country-item">
                                <div>{{ country.name }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="required-error" *ngIf="
              addressForm.controls['country'].invalid &&
              (addressForm.controls['country'].dirty ||
                addressForm.controls['country'].touched)
            ">
                    <div *ngIf="addressForm.controls['country'].errors?.['required']">
                        Please select country.
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label">Full name (First and Last name)<sup class="required">*</sup></label>
                <input type="text" formControlName="name" placeholder="Enter your name" class="form-control" />
                <div class="required-error" *ngIf="
              addressForm.controls['name'].invalid &&
              (addressForm.controls['name'].dirty ||
                addressForm.controls['name'].touched)
            ">
                    <div *ngIf="addressForm.controls['name'].errors?.['required']">
                        Please enter name.
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label">Mobile number<sup class="required">*</sup></label>
                <input type="tel" maxlength="10" formControlName="phone" placeholder="Enter your number"
                    class="form-control" />
                <div class="required-error" *ngIf="
              addressForm.controls['phone'].invalid &&
              (addressForm.controls['phone'].dirty ||
                addressForm.controls['phone'].touched)
            ">
                    <div *ngIf="addressForm.controls['phone'].errors?.['pattern']">
                        Please enter mobile number.
                    </div>
                    <!-- <div
              *ngIf="addressForm.controls['phone'].errors?.['minlength'] || addressForm.controls['phone'].errors?.['pattern']"
            >
              Please enter valid mobile number.
            </div> -->
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label">Address<sup class="required">*</sup></label>
                <input type="tel" formControlName="address" placeholder="Flat, House no., Building, Company, Apartment"
                    class="form-control mb-1" />
                <div class="required-error" *ngIf="
              addressForm.controls['address'].invalid &&
              (addressForm.controls['address'].dirty ||
                addressForm.controls['address'].touched)
            ">
                    <div *ngIf="addressForm.controls['address'].errors?.['required']">
                        Please enter address.
                    </div>
                </div>
                <input type="tel" formControlName="basicAddress" placeholder="Area, Street, Sector, Village"
                    class="form-control" />
            </div>

            <div class="mb-3">
                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label">Zip Code<sup class="required">*</sup></label>
                        <input type="number" name="name" onKeyPress="if(this.value.length==6) return false;"
                            formControlName="pincode" placeholder="Enter your pincode" class="form-control" />
                        <div class="required-error" *ngIf="
                  addressForm.controls['pincode'].invalid &&
                  (addressForm.controls['pincode'].dirty ||
                    addressForm.controls['pincode'].touched)
                ">
                            <div *ngIf="addressForm.controls['pincode'].errors?.['required']">
                                Please enter pincode.
                            </div>
                            <div *ngIf="addressForm.controls['pincode'].errors?.['minlength']">
                                Please enter valid zipcode.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <label class="form-label">Town/City<sup class="required">*</sup></label>
                        <input type="text" formControlName="city" placeholder="Enter your city" class="form-control" />
                        <div class="required-error" *ngIf="
                  addressForm.controls['city'].invalid &&
                  (addressForm.controls['city'].dirty ||
                    addressForm.controls['city'].touched)
                ">
                            <div *ngIf="addressForm.controls['city'].errors?.['required']">
                                Please enter city.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label">State<sup class="required">*</sup></label>
                <input type="text" formControlName="state" placeholder="Enter your state" class="form-control" />
                <div class="required-error" *ngIf="
              addressForm.controls['state'].invalid &&
              (addressForm.controls['state'].dirty ||
                addressForm.controls['state'].touched)
            ">
                    <div *ngIf="addressForm.controls['state'].errors?.['required']">
                        Please enter state.
                    </div>
                </div>
            </div>

            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" formControlName="default" id="default" />
                <label class="form-check-label" for="default">
                    Make this my default address</label>
            </div>

            <div style="display: flex; justify-content: flex-end;">
                <button mat-raised-button color="primary" (click)="submit()"
                    [disabled]="!addressForm.valid">Submit</button>
            </div>
        </form>
    </div>
</p-dialog>